import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import { getProductImageSrc, productInitials } from '@/lib/productImages';

const SIZES = {
  table: 'h-11 w-11',
  mobile: 'h-12 w-12 md:h-14 md:w-14',
  tablet: 'h-14 w-14',
  recipe: 'h-16 w-16',
  verify: 'h-[72px] w-[72px]'
};

export default function ProductThumbnail({ item, src, alt, size = 'mobile', className }) {
  const resolved = src || getProductImageSrc(item);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [resolved]);
  const label = alt || item?.commercial_name || item?.ingredient_name || item?.output_product_name || item?.name || 'Prodotto';
  return (
    <span className={cn('product-thumbnail', SIZES[size] || SIZES.mobile, className)}>
      {resolved && !failed ? (
        <img src={resolved} alt={label} loading="lazy" onError={() => setFailed(true)} />
      ) : (
        <span aria-label={`Immagine non disponibile per ${label}`}>{productInitials(item || { name: label })}</span>
      )}
    </span>
  );
}
